// extracted by mini-css-extract-plugin
export var cardIcon = "_96-4";
export var checkboxCard = "_96-0";
export var checkboxCardSelected = "_96-3";
export var disabled = "_96-1";
export var outerBorder = "_96-2";
export var spacerMedium = "_96-7";
export var spacerSmall = "_96-6";
export var spacerXsmall = "_96-5";